import './footer.css';
import { Link } from 'react-router-dom';
import Chatbot from '../chatbot/Chatbot';
import { itemCategoryMapping } from '../../models/constants';
import { useState } from 'react';
import Loader from '../loader/Loader';

export const Footer = () => {
  const [isLoading, setIsLoading] = useState(false);
  
  if (isLoading) {
    return <Loader />;
  }

  
  return (
    <footer>
      <Chatbot />
      <ul className='footer__categories'>
        {Object.entries(itemCategoryMapping).map(([item, categories]) => (
          categories.map((category, index) => (
            <li key={`${item}-${category}-${index}`}>
              <Link to={`/forum/${item}/${category}`}>{category}</Link>
            </li>
          ))
        ))}
      </ul>
      <div className="footer__copyright">
        <small>All rights Reserved &copy; Copyright, Survival Interactive</small>
      </div>
    </footer>
  );
}
